import type { MarketTrends } from 'app/shared/models/MarketTrends';

export function isEmpty(marketTrends: MarketTrends): boolean {
  return !marketTrends.medianRent && !marketTrends.curYearRentPrices.length && !marketTrends.prevYearRentPrices.length;
}
